/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable @typescript-eslint/no-inferrable-types */

/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */

export class PreferencesConstants {
	public static maxVolume: number = 10;
	public static minVolume: number = 0;
	public static defaultVolume: number = 1;
	public static defaultTheme: string = 'light';
	public static defaultLang: string = 'gl';
}
